import { createSlice } from "@reduxjs/toolkit";
import { getCategories, getContentPages, getFaqsList } from "./thunk";

const initialState = {
  categories: [],
  showLoginPop: false,
  contentPagesList: [],
  faqsList: [],
  openQuoteModal: false,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState: { ...initialState },
  reducers: {
    manageLoginPop: (state, action) => {
      state.showLoginPop = action.payload;
    },
    manageCategories: (state, action) => {
      state.categories = action.payload;
    },
    manageContentPageList: (state, action) => {
      state.contentPagesList = action.payload;
    },
    manageFaqsList: (state, action) => {
      state.faqsList = action.payload;
    },
    manageQuoteModal: (state, action) => {
      state.openQuoteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, () => {})
      .addCase(getCategories.fulfilled, (state, action) => {
        state.categories = action.payload?.data || [];
      })
      .addCase(getCategories.rejected, () => {});
    builder
      .addCase(getContentPages.pending, () => {})
      .addCase(getContentPages.fulfilled, (state, action) => {
        state.contentPagesList = action.payload?.data || [];
      })
      .addCase(getContentPages.rejected, () => {});
    builder
      .addCase(getFaqsList.pending, () => {})
      .addCase(getFaqsList.fulfilled, (state, action) => {
        state.faqsList = action.payload?.data || [];
      })
      .addCase(getFaqsList.rejected, () => {});
  },
});

export default commonSlice.reducer;
export const {
  manageLoginPop,
  manageCategories,
  manageContentPageList,
  manageFaqsList,
  manageQuoteModal,
} = commonSlice.actions;
